import { useSelector } from 'react-redux';

import { EDealType, EOfferType } from '../../../repositories/offer-card/entities/offer/OfferSchema';
import { selectDealType, selectOfferCategory, selectOfferType } from '../../../selectors';

export const STATIC_DATA = [
  {
    title: 'Арендная ставка по оценке Циан',
    description: 'Поможет арендатору поторговаться, а собственнику — сдать квартиру выгоднее и быстрее',
    tooltipText:
      'Оценку рассчитали, используя объявления похожих квартир. Учли характеристики квартир, наличие мебели и техники, а также условия аренды.',
  },
  {
    title: 'Оценка этого участка от Циан',
    description: 'Поможет покупателю поторговаться, а продавцу — продать участок выгоднее и быстрее',
    tooltipText:
      'Оценку рассчитали, используя объявления похожих участков. Учли участки, снятые с продажи и цены сделок.',
  },
  {
    title: 'Оценка этого дома от Циан',
    description: 'Поможет покупателю поторговаться, а продавцу — продать дом выгоднее и быстрее',
    tooltipText: 'Оценку рассчитали, используя объявления похожих домов. Учли дома, снятые с продажи и цены сделок.',
  },
  {
    title: 'Оценка этой квартиры от Циан',
    description: 'Поможет покупателю поторговаться, а продавцу — продать квартиру выгоднее и быстрее',
    tooltipText:
      'Оценку рассчитали, используя объявления похожих квартир. Учли квартиры, снятые с продажи и цены сделок.',
  },
];

/** TODO: Будет перенесено на бэк в задаче https://jira.cian.tech/browse/VAL-2997 */
export const useStaticData = () => {
  const offerCategory = useSelector(selectOfferCategory);
  const offerType = useSelector(selectOfferType);
  const dealType = useSelector(selectDealType);

  if (dealType === EDealType.Rent) {
    return STATIC_DATA[0];
  }

  if (offerType === EOfferType.Suburban) {
    return offerCategory === 'landSale' ? STATIC_DATA[1] : STATIC_DATA[2];
  }

  return STATIC_DATA[3];
};
